import { ResortPhotosData } from 'components/widget/types';
import Link from 'next/link';
import { ImageComponent } from 'components/common/ImageComponent';
import styles from './styles.module.scss';

interface Props {
  photos: ResortPhotosData;
  shouldShowViewAll?:boolean;
}

export const ImagesSection = ({ photos, shouldShowViewAll }:Props) => {
  if (photos.length < 3) {
    return null;
  }

  return (
    <section id={styles.images}>
      <div className="column">
        <div className={styles.main_image}>
          <ImageComponent
            alt={photos[0].name}
            src={photos[0].cdnUrl}
          />
        </div>
        <div className={styles.row}>
          <div>
            <ImageComponent
              alt={photos[1].name}
              src={photos[1].cdnUrl}
              className={styles.h_100}
            />
          </div>
          <div>
            <ImageComponent
              alt={photos[2].name}
              src={photos[2].cdnUrl}
              className={styles.h_100}
            />
            {shouldShowViewAll && (
            <>
              <div className={styles.blueOverlay} />
              { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link href="#" className={styles.allImagesButton}>
                View all images
              </Link>
            </>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};
